import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const EventsFormTypeTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("string"), optionIs("FormSelect", true))
);

export default EventsFormTypeTester;
